import Tag from "../../common/components/ui/Tag";
import { RegionalNamespaces } from "@pslifestyle/common/src/constants/translations";
import getCategoryFromSortKey from "@pslifestyle/common/src/helpers/getCategoryFromSortKey";
import { useTranslation } from "react-i18next";

export interface Props {
  sortKey: string;
}

const QuestionnaireCategoryTag: React.FC<Props> = ({ sortKey }) => {
  const { t } = useTranslation([
    "common",
    RegionalNamespaces.QUESTION_AND_RECOMMENDATIONS,
  ]);

  const category = getCategoryFromSortKey(sortKey);

  if (!category) {
    return null;
  }
  const paddingY = category === "demographic" ? "my-5" : "my-2";

  return (
    <Tag
      filter={category}
      key={category}
      variant={category}
      className={`self-center ${paddingY}`}
    >
      {t(`categories.${category}`, {
        ns: "common",
      })}
    </Tag>
  );
};

export default QuestionnaireCategoryTag;
